export default __webpack_public_path__ + "static/media/1-1-4.8e0c8cc5.webp";